import { createClient } from '@supabase/supabase-js';

// Get Supabase credentials from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validate that we have valid credentials
const isValidUrl = (url) => {
  if (!url || url === 'YOUR_SUPABASE_URL') return false;
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
};

// Check if Supabase is configured
export const isSupabaseConfigured = isValidUrl(supabaseUrl) && supabaseAnonKey && supabaseAnonKey !== 'YOUR_SUPABASE_ANON_KEY';

// Create Supabase client only if credentials are valid
let supabase;

if (isSupabaseConfigured) {
  supabase = createClient(supabaseUrl, supabaseAnonKey);
} else {
  // Create a mock client that will show configuration errors
  console.warn('⚠️ Supabase is not configured. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env file.');
  
  // Create a client with placeholder values that will fail gracefully
  // We'll handle this in the Resources component
  supabase = {
    auth: {
      getSession: async () => ({ data: { session: null }, error: { message: 'Supabase not configured' } }),
      signUp: async () => ({ data: null, error: { message: 'Please configure Supabase credentials in .env file' } }),
      signInWithPassword: async () => ({ data: null, error: { message: 'Please configure Supabase credentials in .env file' } }),
      signOut: async () => ({ error: { message: 'Supabase not configured' } }),
      onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
      updateUser: async () => ({ error: { message: 'Supabase not configured' } }),
      resetPasswordForEmail: async () => ({ error: { message: 'Please configure Supabase credentials in .env file' } })
    },
    from: () => ({
      insert: () => ({ error: { message: 'Supabase not configured', code: 'NOT_CONFIGURED' } })
    })
  };
}

export { supabase };
